module.exports = __webpack_public_path__ + "img/dh2.7b30f94c.png";